export const sorts = {
  default: [],
  options: [
    // {
    //   name: 'Date Created',
    //   key: 'date_created',
    //   options: [{ key: '-created_at', value: 'Newest' }, { key: 'created_at', value: 'Oldest' }]
    // },
    // {
    //   name: 'Url',
    //   key: 'url',
    //   options: [{ key: '-url', value: 'Asc' }, { key: 'url', value: 'Desc' }]
    // },
    // {
    //   name: 'First clicked',
    //   key: 'first_clicked',
    //   options: [{ key: '-first_clicked', value: 'Newest' }, { key: 'first_clicked', value: 'Oldest' }]
    // },
    {
      name: 'Filtered Clicks',
      key: 'filtered_clicks',
      options: [{ key: '-filtered_clicks', value: 'Most' }, { key: 'filtered_clicks', value: 'Least' }]
    },
    {
      name: 'Filtered Commissions',
      key: 'filtered_commissions',
      options: [{ key: '-filtered_commissions', value: 'Most' }, { key: 'filtered_commissions', value: 'Least' }]
    }
    // {
    //   name: 'Filtered Conversion rate',
    //   key: 'filtered_conversion_rate',
    //   options: [{ key: '-filtered_conversion_rate', value: 'Most' }, { key: 'filtered_conversion_rate', value: 'Least' }]
    // },
    // {
    //   name: 'Filtered GMV',
    //   key: 'filtered_gmv',
    //   options: [{ key: '-filtered_gmv', value: 'Most' }, { key: 'filtered_gmv', value: 'Least' }]
    // },
    // {
    //   name: 'Lifetime Clicks',
    //   key: 'lifetime_clicks',
    //   options: [{ key: '-lifetime_clicks', value: 'Most' }, { key: 'lifetime_clicks', value: 'Least' }]
    // },
    // {
    //   name: 'Lifetime Commissions',
    //   key: 'lifetime_commissions',
    //   options: [{ key: '-lifetime_commissions', value: 'Most' }, { key: 'lifetime_commissions', value: 'Least' }]
    // },
    // {
    //   name: 'Lifetime Conversion rate',
    //   key: 'lifetime_conversion_rate',
    //   options: [{ key: '-lifetime_conversion_rate', value: 'Most' }, { key: 'lifetime_conversion_rate', value: 'Least' }]
    // },
    // {
    //   name: 'Lifetime GMV',
    //   key: 'lifetime_gmv',
    //   options: [{ key: '-lifetime_gmv', value: 'Most' }, { key: 'lifetime_gmv', value: 'Least' }]
    // },
    // {
    //   name: 'Name',
    //   key: 'name',
    //   options: [{ key: '-name', value: 'Asc' }, { key: 'name', value: 'Desc' }]
    // },
    // {
    //   name: 'Tags',
    //   key: 'tags',
    //   options: [{ key: '-tags', value: 'Asc' }, { key: 'tags', value: 'Desc' }]
    // },
    // {
    //   name: 'Short Code',
    //   key: 'short_code',
    //   options: [{ key: '-short_code', value: 'Asc' }, { key: 'short_code', value: 'Desc' }]
    // },
    // {
    //   name: 'Last Clicked',
    //   key: 'last_clicked',
    //   options: [{ key: '-last_clicked', value: 'Asc' }, { key: 'last_clicked', value: 'Desc' }]
    // }
  ]
};